import {SearchScopeEnum} from "../../../shared/enums/search-scope.enum";
import {EmptySearchParamsFilterModel} from "../../../shared/models/search/params/filters/empty-search-params-filter.model";
import {SearchParamsModel} from "../../../shared/models/search/params/search-params.model";

export class ContentSearchParamsModel extends SearchParamsModel {
    public constructor(
        public searchScope: SearchScopeEnum,
        public searchText: string,
        public forcedSorting: boolean,
        pageNumber: number,
        filter: EmptySearchParamsFilterModel,
    ) {
        super(pageNumber, filter);
    }
}
